webpackJsonp([1],{

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-section"},[_c('div',{staticClass:"uk-container"},[_c('div',{staticClass:"uk-grid-match uk-child-width-1-3@m",attrs:{"uk-grid":""}},_vm._l((this.posts),function(post){return _c('div',{key:post.id},[_c('div',{staticClass:"uk-card uk-card-default uk-card-small",on:{"click":function($event){_vm.displayPost(post)}}},[_c('div',{staticClass:"uk-card-media-top"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.featuredImage(post)),expression:"featuredImage(post)"}],attrs:{"alt":post.title.rendered}})]),_vm._v(" "),_c('div',{staticClass:"uk-card-body"},[_c('h2',{staticClass:"uk-card-title",domProps:{"innerHTML":_vm._s(post.title.rendered)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(post.excerpt.rendered)}})])])])})),_vm._v(" "),_c('div',{staticClass:"section has-text-centered"},[_c('button',{staticClass:"uk-button uk-button-primary",on:{"click":function($event){_vm.getPosts(_vm.page)}}},[(!_vm.isLoading)?_c('span',[_vm._v("Load More Stories")]):_vm._e(),_vm._v(" "),(_vm.isLoading)?_c('div',{staticClass:"uk-text-center",attrs:{"uk-spinner":""}}):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostView_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3155ea81_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostView_vue__ = __webpack_require__(104);
function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PostView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3155ea81_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PostView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 103:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 104:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-section"},[_c('div',{staticClass:"uk-container"},[_c('div',{staticClass:"uk-article"},[_c('h1',{staticClass:"uk-article-title",domProps:{"innerHTML":_vm._s(_vm.post.title.rendered)}}),_vm._v(" "),_c('div',{staticClass:"uk-article-lead",domProps:{"innerHTML":_vm._s(_vm.post.excerpt.rendered)}}),_vm._v(" "),_c('div',{attrs:{"id":"postContent"},domProps:{"innerHTML":_vm._s(_vm.postContent)}})]),_vm._v(" "),_c('button',{staticClass:"uk-button uk-button-primary",on:{"click":_vm.fbShare}},[_vm._v("Share on Facebook")]),_vm._v(" "),(!_vm.comments)?_c('button',{staticClass:"uk-button uk-button-default",on:{"click":_vm.fbComments}},[_vm._v("Load Comments")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"fb-comments",attrs:{"id":"fb-comments","data-href":'http://faithit.com/' + _vm.$route.params.slug,"data-numposts":"5","data-width":"100%"}}),_vm._v(" "),_c('a',{staticClass:"uk-icon-button uk-box-shadow-large uk-button-primary",attrs:{"href":"#share-modal","id":"share-button","uk-toggle":"","uk-icon":"icon: social; ratio: 2"}})]),_vm._v(" "),_c('div',{staticClass:"uk-flex-top",attrs:{"id":"share-modal","uk-modal":""}},[_c('div',{staticClass:"uk-modal-dialog uk-modal-body uk-margin-auto-vertical"},[_c('button',{staticClass:"uk-modal-close-default",attrs:{"type":"button","uk-close":""}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('p',{staticClass:"uk-text-center share-buttons"},[_c('a',{staticClass:"uk-icon-button uk-box-shadow-medium uk-button-primary",attrs:{"href":_vm.facebookShare,"uk-icon":"icon: facebook; ratio: 1.5","target":"_blank"}}),_vm._v(" "),_c('a',{staticClass:"uk-icon-button uk-box-shadow-medium uk-button-primary",attrs:{"href":_vm.twitterShare,"uk-icon":"icon: twitter; ratio: 1.5","target":"_blank"}}),_vm._v(" "),_c('a',{staticClass:"uk-icon-button uk-box-shadow-medium uk-button-primary",attrs:{"href":_vm.pinterestShare,"uk-icon":"icon: pinterest; ratio: 1.5","target":"_blank"}})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-modal-header"},[_c('h2',{staticClass:"uk-modal-title uk-text-center"},[_vm._v("Share")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uikit__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uikit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uikit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit_dist_js_uikit_icons__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uikit_dist_js_uikit_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uikit_dist_js_uikit_icons__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_0_uikit___default.a.use(__WEBPACK_IMPORTED_MODULE_1_uikit_dist_js_uikit_icons___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(41);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      page: 0,
      posts: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].posts,
      isLoading: false
    };
  },

  methods: {
    getPosts: function getPosts(page) {
      var _this = this;

      this.isLoading = true;
      this.page++;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://faithit.com/wp-json/wp/v2/posts?page=' + this.page).then(function (response) {
        var _posts;

        var result = response.data;
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].posts = result;
        (_posts = _this.posts).push.apply(_posts, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(result));
        _this.isLoading = false;
      }).catch(function (e) {
        _this.page--;
        _this.errors.push(e);
        console.log(e);
        _this.isLoading = false;
      });
    },
    displayPost: function displayPost(post) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].selectedPost = post;
      this.$router.push({
        name: 'post',
        params: {
          slug: post.slug
        }
      });
    },

    featuredImage: function featuredImage(post) {
      return post.better_featured_image.source_url.replace(/(http:\/\/faithit\.com)/g, 'https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com');
    }
  },
  mounted: function mounted() {
    if (!Array.isArray(this.posts) || !this.posts.length) {
      this.getPosts(this.page);
    }
  },

  filters: {
    cdn: function cdn(value) {
      return value.replace('http://faithit.com', 'https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com');
    }
  }
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var store = {
  posts: [],
  selectedPost: undefined
};

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(41);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global FB */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      post: __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].selectedPost,
      inlineAds: 0,
      comments: false
    };
  },
  created: function created() {
    this.fbInit();
  },
  mounted: function mounted() {
    var _this = this;

    console.log("post mounted");
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if (__WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].selectedPost === undefined) {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://faithit.com/wp-json/wp/v2/posts?slug=' + this.$route.params.slug).then(function (response) {
        var result = response.data[0];
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].selectedPost = result;
        _this.post = result;
      }).catch(function (e) {
        _this.errors.push(e);
        console.log(e);
      });
    }

    this.addAds();

    FB.XFBML.parse(document.body);
  },

  methods: {
    fbInit: function fbInit() {
      window.fbAsyncInit = function () {
        FB.init({
          appId: '1415952248472022',
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v2.11'
        });
      };

      (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    },
    fbComments: function fbComments() {
      FB.XFBML.parse(document.getElementById('fb-comments'));
      this.comments = true;
    },
    fbShare: function fbShare() {
      FB.ui({
        method: 'share',
        href: 'https://faithit.com/' + this.$route.params.slug
      }, function (response) {});
    },
    prebidInit: function prebidInit() {
      (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);js.id = id;
        js.src = "https://faithit.com/wp-content/themes/faithit-v3/assets/js/dfp-single.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'prebid-jssdk');
    },

    // Doesn't work on initial page load
    addAds: function addAds() {
      var element = document.getElementById('postContent');
      for (var i = 1; i <= element.children.length; i++) {
        if (i % 7 === 1 && this.inlineAds < 4) {
          this.inlineAds++;
          element.children[i].insertAdjacentHTML('afterend', 'ad here<div id="inline-mobile' + this.inlineAds + '" class="uk-text-center"><script type="text/javascript">googletag.cmd.push(function() { googletag.display("inline-mobile' + this.inlineAds + '"); });<\/script></div>');
        }
      }
      element.children[0].insertAdjacentHTML('afterend', '<meta property="inline-ad-count" content="' + this.inlineAds + '">');
      console.log('add count: ' + this.inlineAds);
      this.prebidInit();
      fetchHeaderBids();
    }
  },
  computed: {
    postContent: function postContent() {
      return this.post.content.rendered.replace(/(http:\/\/faithit\.com\/wp-content\/)/g, 'https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com/wp-content/');
    },
    facebookShare: function facebookShare() {
      return 'https://www.facebook.com/sharer/sharer.php?u=https%3A//faithit.com/' + this.$route.params.slug;
    },
    twitterShare: function twitterShare() {
      var content = this.post.title.rendered + ' https://faithit.com/' + this.$route.params.slug + ' via @sharefaithit';
      return 'https://twitter.com/home?status=' + encodeURIComponent(content);
    },
    pinterestShare: function pinterestShare() {
      var image = encodeURIComponent(this.post.better_featured_image.source_url.replace(/(http:\/\/faithit\.com)/g, 'https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com'));
      var description = encodeURIComponent(this.post.title.rendered);
      return 'https://pinterest.com/pin/create/button/?url=https%3A//faithit.com/' + this.$route.params.slug + '&media=' + image + '&description=' + description;
    }
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_analytics__);



// import 'bulma/css/bulma.css'



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_analytics___default.a, {
  id: 'UA-81869406-3',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d45f6a86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(50);
function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d45f6a86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 46:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"uk-navbar-container"},[_c('div',{staticClass:"uk-container uk-container-expand"},[_c('nav',{staticClass:"uk-navbar",attrs:{"uk-navbar":""}},[_c('div',{staticClass:"uk-navbar-left"},[_c('router-link',{staticClass:"uk-navbar-item uk-logo",attrs:{"to":"/"}},[_c('img',{attrs:{"src":"https://faithit-eszuskq0bptlfh8awbb.stackpathdns.com/wp-content/themes/faithit-v3/assets/images/Faithit_Blue.svg","alt":"Faithit"}})])],1),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-navbar-right"},[_c('a',{staticClass:"uk-navbar-toggle",attrs:{"uk-navbar-toggle-icon":"","href":"#","uk-toggle":"target: #offcanvas-flip"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"uk-section uk-section-muted"},[_c('div',{staticClass:"uk-container"},[_c('p',[_vm._v("\n        Made with ❤️  by Faithit\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-offcanvas-content"},[_c('div',{attrs:{"id":"offcanvas-flip","uk-offcanvas":"flip: true; overlay: true"}},[_c('div',{staticClass:"uk-offcanvas-bar uk-flex uk-flex-column"},[_c('ul',{staticClass:"uk-nav uk-nav-primary uk-nav-center uk-margin-auto-vertical"},[_c('li',{staticClass:"uk-active"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Active")])]),_vm._v(" "),_c('li',{staticClass:"uk-parent"},[_c('a',{attrs:{"href":"#"}},[_vm._v("Parent")]),_vm._v(" "),_c('ul',{staticClass:"uk-nav-sub"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Sub item")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Sub item")])])])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-header"},[_vm._v("Header")]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"uk-margin-small-right",attrs:{"uk-icon":"icon: table"}}),_vm._v(" Item")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"uk-margin-small-right",attrs:{"uk-icon":"icon: thumbnails"}}),_vm._v(" Item")])]),_vm._v(" "),_c('li',{staticClass:"uk-nav-divider"}),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_c('span',{staticClass:"uk-margin-small-right",attrs:{"uk-icon":"icon: trash"}}),_vm._v(" Item")])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HomeView__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PostView__ = __webpack_require__(102);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_HomeView__["a" /* default */]
  }, {
    path: '/:slug',
    name: 'post',
    component: __WEBPACK_IMPORTED_MODULE_3__components_PostView__["a" /* default */]
  }]
}));

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeView_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a77e28a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeView_vue__ = __webpack_require__(101);
function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a77e28a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a77e28a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[43]);


// WEBPACK FOOTER //
// static/js/app.eacebf8d64bda7f723b4.js